enum PrivacyType {
  Everybody = 2,
  Contacts = 1,
  Nobody = 0
}

export default PrivacyType;
